import CommonDocument from '@/modules/common/hiring/models/MID/CommonDocument'
import ForeignHealthPolicyHolderSaveDocument from './ForeignHealthPolicyHolderSaveDocument'

export default class ForeignHealthSaveDocumentRequest {
  /** (UUID): Identificador único de la cotización. Ejemplo: 23423-643hbf-74834hj. */
  quotationId!: string

  /** Lista de documentos a guardar. */
  document!: CommonDocument[]

  /** Información del titular de la póliza. */
  policyHolder!: ForeignHealthPolicyHolderSaveDocument

  constructor(data: any) {
    this.quotationId = data.quotationId
    this.document = data.document?.map((doc: any) => new CommonDocument(doc))
    if (data.policyHolder)
      this.policyHolder = new ForeignHealthPolicyHolderSaveDocument(data.policyHolder)
  }
}
